"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dismissCompanyRecallReview = exports.confirmCompanyRecallReview = exports.openCompanyRecallReview = exports.listCompanyRecallReviews = void 0;
const ApiClient_1 = require("../ApiClient");
const listCompanyRecallReviews = (status) => ApiClient_1.apiClient.get(`/api/company-recall-reviews${status ? `?status=${status}` : ''}`);
exports.listCompanyRecallReviews = listCompanyRecallReviews;
const openCompanyRecallReview = (tick, producer) => ApiClient_1.apiClient.post('/api/company-recall-reviews', { tick, ...(producer ? { producer } : {}) });
exports.openCompanyRecallReview = openCompanyRecallReview;
const confirmCompanyRecallReview = (id, items) => ApiClient_1.apiClient.post(`/api/company-recall-reviews/${encodeURIComponent(id)}/confirm`, { items });
exports.confirmCompanyRecallReview = confirmCompanyRecallReview;
const dismissCompanyRecallReview = (id) => ApiClient_1.apiClient.post(`/api/company-recall-reviews/${encodeURIComponent(id)}/dismiss`);
exports.dismissCompanyRecallReview = dismissCompanyRecallReview;
